import { useEvents } from '@parcel2go/npm-p2g-app';
import { useEffect } from 'react';

export function useCmsContent({ origin, destination }: { origin: string; destination: string }) {
  const events = useEvents();

  useEffect(() => {
    events.emit('SET_CONTENT_PARAMS', { origin, destination });
  }, [origin, destination, events]);

  return {};
}
